<div class="page-stepper-header">
    <ul class="steps">
        <li class="step" *ngFor="let step of steps; let index = index;"
            [class.active]="isStepActive(index)"
            [class.complete]="isStepComplete(index)">
            <div class="step-card">
                <div class="step-counter">
                    <i *ngIf="isStepComplete(index)"
                       class="material-icons">check</i>
                    <span *ngIf="!isStepComplete(index)">{{ index + 1 }}</span>
                </div>
                <div class="step-label">
                    <ng-container *ngTemplateOutlet="step.title"></ng-container>
                </div>
            </div>
            <span class="separator"></span>
        </li>
    </ul>
</div>
<div class="page-stepper-body">
    <app-loading-spinner *ngIf="isLoading" class="loading-animation"></app-loading-spinner>
    <ng-container *ngFor="let step of steps; let index = index;">
        <div class="step-content" *ngIf="!isLoading" [hidden]="index !== activeStepIndex">
            <ng-container *ngTemplateOutlet="step.content; context: {step: step}"></ng-container>
        </div>
    </ng-container>
</div>
<div class="page-stepper-footer">
    <app-button type="simple"
                *ngIf="!isFirstStep"
                [disabled]="isLoading"
                (clicked)="prev()">
        <i class="material-icons">chevron_left</i>  {{ 'generic.buttons.back'| translate }}
    </app-button>
    <div class="spacer"></div>
    <app-button *ngIf="!isLastStep"
                [disabled]="nextDisabled || isLoading"
                type="primary"
                class="next"
                (clicked)="next()">
        {{ 'generic.buttons.next'| translate }}
        <i class="material-icons">chevron_right</i>
    </app-button>
    <app-button *ngIf="isLastStep && submitVisible"
                [disabled]="nextDisabled"
                type="warning"
                class="next"
                [disabled]="isLoading"
                (clicked)="finalSubmit()">
        {{ 'generic.buttons.save'| translate }}
    </app-button>
</div>
